var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIgnoreGrid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icIgnoreGrid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.6541512,9.5000228 L14.1165192,6.0376507 C14.4352343,5.71893519 14.4352343,5.20219659 14.1165192,4.88352667 C13.7978041,4.56481116 13.2811117,4.56481116 12.9623965,4.88352667 L9.4999829,8.34594436 L6.03756928,4.88348108 C5.71885414,4.56476557 5.20216173,4.56476557 4.8834466,4.88348108 C4.56477706,5.20219659 4.56477706,5.71893519 4.8834466,6.03760511 L8.34586022,9.4999772 L4.8834466,12.9623949 C4.56477706,13.2811104 4.56477706,13.797849 4.8834466,14.1165189 C5.20216173,14.4352344 5.71885414,14.4352344 6.03756928,14.1165189 L9.4999829,10.6541012 L12.9623965,14.1165189 C13.2810661,14.4352344 13.7978041,14.4352344 14.1165192,14.1165189 C14.4352343,13.7978034 14.4352343,13.2811104 14.1165192,12.9623949 L10.6541512,9.5000228 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/icon/close-x-Profile",
    transform: "translate(-4.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "colour/light-grey",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIgnoreGrid);
export default __webpack_public_path__ + "static/media/icIgnoreGrid.6d413110a62cde809ffa0456a91d98ba.svg";
export { ForwardRef as ReactComponent };